import { FileCode2, Files, History, MessageSquare, SquareTerminal } from "lucide-react";
import type { IdeHosts } from "./IdeLayout.tsx";
import { HostSlot } from "./PanelHost.tsx";

export type NarrowView = "files" | "code" | "tools" | "agent" | "history";

const TABS: Array<[NarrowView, string, typeof Files]> = [
  ["files", "Files", Files],
  ["code", "Code", FileCode2],
  ["agent", "Agent", MessageSquare],
  ["history", "History", History],
  ["tools", "Tools", SquareTerminal],
];

/**
 * Narrow screens (tablet / phone): one view at a time, chat first. The logical views are Files, Code, Tools, Agent and
 * History; docking and independent visibility are desktop features. The other views stay mounted (detached from the
 * document), so tabs, unsaved edits, terminals and the chat survive switching views.
 */
export function NarrowIde({
  hosts,
  view,
  onView,
}: {
  hosts: IdeHosts;
  view: NarrowView;
  onView: (v: NarrowView) => void;
}) {
  return (
    <div className="ide ide-narrow" data-testid="ide" data-view={view}>
      <div className="narrow-body">
        <HostSlot key={view} host={hosts[view]} />
      </div>
      <nav className="narrow-tabs" aria-label="Views">
        {TABS.map(([id, label, Icon]) => (
          <button
            key={id}
            className={view === id ? "active" : ""}
            aria-pressed={view === id}
            onClick={() => onView(id)}
            data-testid={`narrow-${id}`}
          >
            <Icon size={16} aria-hidden />
            {label}
          </button>
        ))}
      </nav>
    </div>
  );
}
